export enum CadastroSteps{
    basic,
    personalinformations,
    documentation,
    bank,
    insertBank,
    address,
    userProfilePF,
    patrimony
}